module.exports = __webpack_public_path__ + "img/logo.d6da1aee.svg";